import { Mail, Phone, MessageCircle } from 'lucide-react';

const COMERCIAL = [
  { nome: 'Mariana Di Cavalcanti', cargo: 'Gerente Comercial · Conecta',  email: 'mariana@apexpartners.com.br',  whatsapp: '5527999990001', avatar: 'MD' },
  { nome: 'Julia De Cesaro',       cargo: 'Comercial · BRM - BUY',        email: 'julia@apexpartners.com.br',    whatsapp: '5527999990002', avatar: 'JC' },
  { nome: 'Thamille',              cargo: 'Comercial · Setorial',         email: 'thamille@apexpartners.com.br', whatsapp: '5527999990003', avatar: 'TH' },
];

const COORDENACAO = {
  nome: 'Coordenação Produtora',
  email: 'producao@apexpartners.com.br',
};

export function ContatoPortal() {
  return (
    <div className="p-6 space-y-5 max-w-3xl">
      <header>
        <h1 className="text-2xl font-bold text-text">Falar com a Apex</h1>
        <p className="text-sm text-text-2">Time direto pra qualquer dúvida sobre o seu contrato ou eventos</p>
      </header>

      <section>
        <h2 className="text-xs font-bold text-text uppercase tracking-wider mb-3">Time Comercial</h2>
        <div className="space-y-2">
          {COMERCIAL.map(p => (
            <div key={p.email} className="bg-panel border border-border rounded-xl p-4 flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue to-purple text-white font-bold flex items-center justify-center">{p.avatar}</div>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-sm">{p.nome}</div>
                <div className="text-xs text-text-2">{p.cargo}</div>
              </div>
              <div className="flex gap-2 shrink-0">
                <a href={`mailto:${p.email}`} className="px-2.5 py-2 bg-white border border-border rounded-md text-text-2 hover:text-text" title={p.email}>
                  <Mail className="w-4 h-4" />
                </a>
                <a href={`https://wa.me/${p.whatsapp}`} target="_blank" rel="noreferrer"
                   className="px-2.5 py-2 bg-green text-white rounded-md hover:bg-green/90" title="WhatsApp">
                  <MessageCircle className="w-4 h-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xs font-bold text-text uppercase tracking-wider mb-3">Coordenação Produtora</h2>
        <div className="bg-panel border border-border rounded-xl p-4 flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange to-pink text-white font-bold flex items-center justify-center">AP</div>
          <div className="flex-1">
            <div className="font-bold text-sm">{COORDENACAO.nome}</div>
            <div className="text-xs text-text-2">Suporte operacional · pedidos urgentes sobre entregas</div>
          </div>
          <a href={`mailto:${COORDENACAO.email}`} className="px-3 py-2 bg-blue text-white rounded-md text-xs font-bold inline-flex items-center gap-1.5">
            <Mail className="w-3.5 h-3.5" /> Enviar email
          </a>
        </div>
      </section>

      <p className="text-[11px] text-muted italic">
        💡 Pra acompanhar status de uma entrega específica, abre <strong>Entregas</strong> ou o detalhe do evento — lá tem o histórico completo.
      </p>
    </div>
  );
}

void Phone;
